import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '..';
import { IQuestionTag } from '../QuestionSlice';
import { getTagsList } from './TagsApi';

export interface IQuestionTagState {
  status: 'idle' | 'loading' | 'rejected';
  count: number;
  list: Array<IQuestionTag>;
}

const initialState: IQuestionTagState = {
  status: 'idle',
  count: 0,
  list: [],
};

export const QuestionTagSlice = createSlice({
  name: 'questionTag',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTagsList.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getTagsList.fulfilled, (state, action) => {
        state.status = 'idle';
        state.count = action.payload.totalDocs;
        state.list = action.payload.docs;
      })
      .addCase(getTagsList.rejected, (state) => {
        state.status = 'rejected';
      });
  },
});

export const getTagsState = (state: RootState): RootState['tags'] => state.tags;

export * from './TagsApi';
export default QuestionTagSlice.reducer;
